module.exports = __webpack_public_path__ + "static/media/mymeds_img_1.f10b66fe.png";